const ALLOWED_TAGS = new Set([
  "P", "BR", "STRONG", "B", "EM", "I", "U", "S", "H1", "H2", "H3",
  "UL", "OL", "LI", "A", "DIV", "SPAN", "BLOCKQUOTE",
]);

export const looksLikeHtml = (text: string): boolean =>
  /<(p|br|div|strong|b|em|i|u|s|h[1-3]|ul|ol|li|a|span|blockquote)(\s[^>]*)?\/?>/i.test(text);

export const plainTextToHtml = (text: string): string =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\r?\n/g, "<br>");

const cleanNode = (node: Node): Node | null => {
  if (node.nodeType === Node.TEXT_NODE) return document.createTextNode(node.textContent || "");
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const el = node as HTMLElement;
  const tag = el.tagName;
  if (tag === "SCRIPT" || tag === "STYLE") return null;

  const frag = document.createDocumentFragment();
  el.childNodes.forEach((child) => {
    const cleaned = cleanNode(child);
    if (cleaned) frag.appendChild(cleaned);
  });

  if (!ALLOWED_TAGS.has(tag)) return frag;

  const out = document.createElement(tag.toLowerCase());
  if (tag === "A") {
    const href = (el.getAttribute("href") || "").trim();
    if (/^(https?:|mailto:)/i.test(href)) {
      out.setAttribute("href", href);
      out.setAttribute("target", "_blank");
      out.setAttribute("rel", "noopener noreferrer");
    }
  }
  out.appendChild(frag);
  return out;
};

export function sanitizeHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const target = document.createElement("div");
  doc.body.childNodes.forEach((child) => {
    const cleaned = cleanNode(child);
    if (cleaned) target.appendChild(cleaned);
  });
  return target.innerHTML;
}

export const isHtmlEmpty = (html: string): boolean => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return !(div.textContent || "").trim();
};
